import { useDispatch, useSelector } from "react-redux";
import { setSection } from "../../../../assignmentSlice";
import UserInputBar from "../../../widgets/UserInputBar";

const VocabularyPage = ({
  pageList,
  currentPage,
  setPageList,
  currentIndex,
  userInput,
  setUserInput,
}) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const handleChange = (e) => {
    setUserInput(e.target.value);
    if (currentPage.isSubmitted) {
      const newPageList = pageList.map((page, pageIndex) => {
        if (pageIndex === currentIndex) {
          return {
            ...page,
            isSubmitted: false,
          };
        }
        return page;
      });
      setPageList(newPageList);
      dispatch(setSection({ ...section, answer: newPageList }));
    }
  };

  const handleSetAnswer = () => {
    const newPageList = pageList.map((page, pageIndex) => {
      if (pageIndex === currentIndex) {
        return {
          ...page,
          input: userInput,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "50px",
        width: "90%",
      }}
    >
      <div
        style={{
          fontSize: "20px",
        }}
      >
        {"주어진 단어의 한글 뜻을 적으시오."}
      </div>
      <div
        style={{
          fontSize: "28px",
          textAlign: "center",
          lineHeight: "1.5",
        }}
      >
        {currentPage.question}
      </div>
      <div style={{ width: "60%", position: "relative" }}>
        <UserInputBar
          userInput={userInput}
          handleChange={handleChange}
          type={"comprehensive"}
          handleSetAnswer={handleSetAnswer}
          onlyUnderline={true}
          isSubmitted={currentPage.isSubmitted}
        />
      </div>
    </div>
  );
};

export default VocabularyPage;
